export default function isSiteBuilder(){
  if (!window.OrendaGetResponse || window.isSiteBuilder) return true;
  return false;
}